import { useEffect, useState } from 'react';

/**
 * State for an optimistic upload preview whose `blob:` URL this component
 * owns. The previous URL is revoked when it is replaced, cleared, or the
 * component unmounts. `data:` URLs pass through untouched.
 *
 * The uploader's Skip path hands over `URL.createObjectURL(file)` and leaves
 * its release to the consumer; plain `useState` never released it, so every
 * skipped photo kept its full original file alive for the page's lifetime.
 */
export function useOwnedPreviewUrl() {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    return () => {
      if (url?.startsWith('blob:')) URL.revokeObjectURL(url);
    };
  }, [url]);

  return [url, setUrl] as const;
}
